import { useEffect } from "react";
import { Mic, Square } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { useSpeechRecognition } from "@/hooks/useSpeechRecognition";
import { cn } from "@/lib/utils";

/**
 * Mic button for dictation. Appends finalised speech to a text field via onText.
 * Completely optional – the text field is always editable by hand.
 */
export const VoiceInput = ({ onText, testid = "voice-input", className, size = "sm", label = "Snakk inn" }) => {
  const { supported, listening, interim, error, toggle } = useSpeechRecognition({ onFinal: onText });

  useEffect(() => {
    if (!error) return;
    const msg =
      error === "not-allowed"
        ? "Mikrofon-tilgang vart avvist. Gi tilgang i nettlesaren for å diktere."
        : error === "no-speech"
          ? "Høyrde ingen tale. Prøv igjen."
          : "Taleinnskriving feila. Skriv teksten manuelt.";
    toast.error(msg);
  }, [error]);

  if (!supported) return null;

  return (
    <div className={cn("flex items-center gap-2", className)}>
      <Button
        type="button"
        size={size}
        variant={listening ? "dark" : "outline"}
        data-testid={testid}
        onClick={toggle}
        aria-pressed={listening}
        className={cn("relative", listening && "mic-recording")}
      >
        {listening ? <Square className="h-3.5 w-3.5 fill-current" /> : <Mic />}
        {listening ? "Stopp" : label}
      </Button>
      {listening && (
        <span className="truncate text-xs text-muted-foreground" data-testid={`${testid}-interim`}>
          {interim ? `“${interim}”` : "Lyttar … snakk tydeleg"}
        </span>
      )}
    </div>
  );
};
